<script>
import router from "../../router/routes";
import NavBar from "@/components/nav-bar";
import SideBar from "@/components/side-bar";
import Footer from "@/components/footer";
import { api } from "@/state/services";

export default {
  components: { NavBar, SideBar, Footer },
  beforeCreate: function() {
    document.body.className = 'main';
  },
  data() {
    return {
      isMenuCondensed: false,

      plans: null,

      plan: {
        modal: false,
        status: null,
        order: {
          id: null,
        },
      },
    };
  },
  created: () => {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
  },
  methods: {
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
    getPlans() {
      api.get("plan").then((response) => {
        if (response.data.status === "success") {
          this.plans = response.data.list;
        }
      });
    },
    checkPlan() {
      api.get("plan/check").then((response) => {
        this.plan.status = response.data.status;

        if (response.data.status === "inactive") {
          if (response.data.order.id > 0) {
            if (this.$route.path !== "/store/order/" + response.data.order.id) {
              this.$router.push("/store/order/" + response.data.order.id);
            }
          } else {
            this.plan.modal = true;
          }
        }
      });
    },
    choosePlan(id) {
      api
        .post("plan", {
          id: id,
        })
        .then((response) => {
          if (response.data.status === "success") {
            this.plan.modal = false;

            if (this.$route.path == "/") {
              this.$router.push("/store/order/" + response.data.order.id);
            } else {
              this.$router.push("/");
            }
          }
        })
    },
  },
  mounted() {
    this.getPlans();
    this.checkPlan();
  },
};
</script>

<template>
  <div id="layout-wrapper">
    <NavBar :isCondensed="isMenuCondensed" />
    <SideBar :isCondensed="isMenuCondensed" />
    <div class="main-content">
      <div class="page-content">
        <div class="container-fluid">
          <slot />
        </div>
      </div>
      <Footer />
    </div>

    <b-modal v-model="plan.modal" title="Escolha seu plano" size="xl" centered no-close-on-esc no-close-on-backdrop hide-header-close hide-header hide-footer>
      <div>
        <div class="mt-2 mb-4 text-center">
          <h4>Escolha seu Plano</h4>
        </div>
        <div class="row justify-content-center">
          <div class="col-md-4" v-for="(plan, id) in plans" :key="id">
            <div class="bg-soft-light rounded p-3 mb-3 text-center">
              <h3 class="mt-3">{{ plan.name }}</h3>
              <hr>
              <h3><strong>{{ plan.value | currency }}</strong> <sup class="text-uppercase font-size-14">Adesão</sup></h3>
              <button class="btn btn-default btn-lg btn-block mt-4 mb-2" v-on:click="choosePlan(plan.id);">
                Escolher
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
